export const ko = {
  // Upload step
  uploadTitle: '공간 사진 업로드',
  uploadHint: '클릭하거나 이미지를 끌어다 놓으세요',
  uploadHintTouch: '눌러서 사진 선택',
  uploadOr: '또는',
  takePhoto: '사진 촬영',
  yourPhotos: '업로드된 사진',
  photoLabel: '{n}번 사진',
  photoCount: '사진 {n}장',
  addPhoto: '사진 추가',
  continue: '계속',
  stepLabel: '단계 {current} / {total}',

  // Style step
  chooseStyle: '인테리어 스타일 선택',
  describeCustomStyle: '원하는 스타일을 직접 설명해주세요',
  uploadReferenceTitle: '레퍼런스 사진 업로드',
  uploadReferenceHint: 'AI 가 이 사진의 톤·소재·분위기를 따라가요. 원본 방 사진은 그대로 유지돼요.',
  removeReference: '레퍼런스 삭제',
  cleanupOptionTidy: '정돈하기',
  cleanupOptionTidyDesc: '가구는 그대로, 잡동사니·쓰레기·정리 안된 것들만 치워요',
  cleanupOptionEmpty: '빈 방으로',
  cleanupOptionEmptyDesc: '가구와 장식을 모두 빼요. 벽·바닥·창문은 그대로',
  cleanupChooseOption: '청소 방식 선택',
  layoutOptionFlow: '동선 우선',
  layoutOptionFlowDesc: '오가기 편하도록 가구 배치를 정리해요',
  layoutOptionSpacious: '시원하게',
  layoutOptionSpaciousDesc: '시야가 트이고 답답하지 않게 — 더 넓어 보여요',
  // 평면도 모드 (2.4.0)
  planChooseOption: '평면도로 무엇을 만들까요?',
  planOption_3d: '3D 평면도',
  planOption_3dDesc: '집 전체를 위에서 본 3D로, 스타일을 입혀서',
  planOption_room: '방 하나 보기',
  planOption_roomDesc: '평면도에서 방을 칠하면 그 방을 눈높이로',
  planOption_clean: '도면 정리',
  planOption_cleanDesc: '손스케치나 흐린 도면을 반듯하게 다시 그려요',
  planCleanKindTitle: '도면 종류',
  planCleanKind_line: '흑백 도면',
  planCleanKind_color: '컬러 평면도',
  planStyleTitle: '스타일',
  planRoomTitle: '어느 방을 볼까요?',
  planRoomSignIn: '로그인하면 평면도에서 방을 골라 볼 수 있어요.',
  planRoomPaint: '평면도에서 방 칠하기',
  planRoomPicked: '고른 방',
  planRoomRepaint: '다시 칠하기',
  planRoomClear: '지우기',
  planRoomNamePlaceholder: '또는 방 이름 (예: 안방)',
  planCropHint: '사진에서 평면도만 꽉 차게 잘라 올리면 더 정확해요.',
  planFirstOnly: '평면도는 첫 번째 사진만 써요.',
  planRoomPickTitle: '방 고르기',
  planRoomPickHint: '보고 싶은 방을 손가락으로 칠하세요. 대충 칠해도 돼요.',
  planRoomPickDone: '이 방으로',
  planRoomNeedPick: '평면도에서 방을 칠하거나 방 이름을 적어 주세요.',
  errNotFloorplan: '평면도가 아닌 것 같아요. 평면도를 올리거나 다른 스타일을 골라 주세요.',
  planRoomFrom: '평면도에서 고른 방',
  planInputLabel: '평면도',
  planOutput_plan_3d: '3D 평면도',
  planOutput_plan_room: '방 보기',
  planOutput_plan_clean: '정리한 도면',
  planOutput_plan_color: '컬러 평면도',
  planRoomFromResult: '방 골라 보기',
  planRoomMake: '이 방 만들기',
  planRoomMeta: '크레딧 {n} · 같은 집의 이 방을 눈높이로',
  layoutChooseOption: '재배치 방식 선택',
  creditEarnHint: '매일 접속하면 +1, 친구 초대하면 +5 크레딧을 받아요.',
  languageHint: '분석 결과도 선택한 언어로 표시돼요.',
  reuseStyle: '— 이전 스타일 재사용 —',
  customPlaceholder: "원하는 인테리어 스타일을 자세히 설명해주세요 (예: '따뜻한 원목 톤의 아늑한 스타일', '금속 포인트의 미래적 미니멀')",
  customStylePublicHint: '커스텀 스타일 문구는 커뮤니티에 익명으로 공개될 수 있어요. 계정 설정에서 끌 수 있어요.',
  communityRankTitle: '지금 뜨는 스타일',
  communityPeople: '{n}명이 사용',
  customStylesChip: '커스텀 스타일',
  galleryRecentBadge: '방금 사용됨',
  timeJustNow: '방금',
  timeAgoMin: '{n}분 전',
  timeAgoHour: '{n}시간 전',
  communityViewAll: '전체 보기',
  galleryTitle: '지금 뜨는 스타일',
  briefsLabel: '소식',
  briefTopupKicker: '크레딧',
  briefTopupTitle: '다음 디자인에 크레딧이 모자라요',
  briefTopupLine: '무료 크레딧은 내일 다시 차요. 지금 더 쓰려면 크레딧 팩.',
  briefSeasonKicker: '시즌 한정',
  briefSeasonTitle: '{name} 스타일이 열렸어요',
  briefSeasonLine: '몇 주 동안만 보이는 시즌 스타일이에요.',
  briefInviteKicker: '친구 초대',
  briefInviteTitle: '친구를 초대하면 둘 다 +{n} 크레딧',
  briefInviteLine: '내 링크를 보내 주세요. 친구가 가입하면 들어와요.',
  galleryEmpty: '아직 이 공간의 인기 스타일이 없어요. 사람들이 쓰기 시작하면 여기에 떠요.',
  galleryBuiltinTitle: '요즘 스타일 랭킹',
  galleryPopularCustom: '요즘 인기 커스텀',
  galleryDiscoverTitle: '커스텀 둘러보기',
  galleryShuffle: '섞기',
  galleryTranslate: '번역해서 보기',
  galleryTranslating: '번역 중…',
  galleryOriginal: '원문 보기',
  galleryLiveTab: '실시간',
  galleryLiveWaiting: '새로 사용되는 스타일을 기다리는 중…',
  galleryLiveTitle: '지금 사용 중',
  galleryRecentCustom: '최근 커스텀 스타일',
  galleryUse: '이 스타일 사용',
  styleShareNotice: '커스텀 스타일 문구는 익명으로 커뮤니티에 공개될 수 있어요.',
  styleShareNoticeSettings: '설정에서 끄기',
  styleShareNoticeOk: '확인',
  communityTopTitle: '인기 커스텀 스타일',
  communityRecentTitle: '방금 다른 사람이 쓴 스타일',
  communityUses: '{n}회 사용',
  communityDesigns: '디자인 {n}개',
  communityDesignsOne: '디자인 {n}개',
  styleShareTitle: '커스텀 스타일 공개',
  styleShareDesc: '내가 쓴 커스텀 스타일 문구를 다른 사람이 발견하고 써볼 수 있어요. 사진은 절대 공개되지 않아요.',
  additionalRequests: '추가 요청 사항',
  optional: '(선택)',
  additionalPlaceholder: "{style} 스타일에 추가하고 싶은 요소가 있나요? (예: '원목 커피테이블 추가', '청록색 포인트 색상')",
  addAdditionalRequest: '+ 추가 요청 사항 넣기',
  generateDesign: '디자인 생성',
  back: '뒤로',

  // Generate step
  generatingOne: 'AI가 인테리어 디자인을 생성하고 있어요…',
  generatingMany: 'AI가 {n}장의 일관된 인테리어 디자인을 생성하고 있어요…',
  generatingOneExterior: 'AI가 외관 리디자인을 생성하고 있어요…',
  generatingManyExterior: 'AI가 {n}장의 일관된 외관 렌더를 생성하고 있어요…',
  generatingOneGarden: 'AI가 정원 리디자인을 생성하고 있어요…',
  generatingManyGarden: 'AI가 {n}장의 일관된 정원 렌더를 생성하고 있어요…',
  generationFailed: '생성 실패',
  tryAgain: '다시 시도',

  // Error messages
  errNoInternet: '인터넷 연결을 확인해주세요.',
  errTimeout: 'AI 응답 시간이 초과됐어요. 다시 시도해주세요.',
  errTooMany: '요청이 너무 많아요. 잠시 후 다시 시도해주세요.',
  errNetwork: '네트워크 오류가 발생했어요. 연결을 확인해주세요.',
  errAI: 'AI 서비스에 문제가 발생했어요. 다시 시도해주세요.',
  errFileType: '지원하지 않는 파일 형식이에요. JPEG, PNG, WebP 이미지를 올려주세요.',
  errFileTooLarge: '파일이 너무 커요. 20MB 이하 이미지를 올려주세요.',
  errPhotoRead: '사진을 읽지 못했어요. 다른 사진으로 시도해주세요.',
  errCameraAccess: '카메라에 접근할 수 없어요. 설정에서 카메라 권한을 허용해주세요.',
  errCameraCapture: '사진을 찍지 못했어요. 다시 시도해주세요.',
  errCaptionSave: '캡션을 저장하지 못했어요. 다시 시도해주세요.',
  imageUnavailable: '이미지를 불러올 수 없어요',
  designShareText: 'archelier 로 만든 {style} 디자인이에요',
  altPhoto: '사진 {n}',
  altOriginal: '원본 {n}',
  altGenerated: '디자인 {n}',
  errInvalidSpace: '이 이미지는 공간으로 읽히지 않았어요. 방이 보이는 사진으로 해주세요 — 벽과 바닥이 함께 나오거나, 방 한쪽 구석이 보이면 돼요.',
  pickAnotherPhoto: '다른 사진 고르기',
  errCustomStyle: '원하는 스타일을 설명해주세요.',
  errSignIn: '로그인에 실패했어요. 다시 시도해주세요.',
  errInsufficientCredits: '크레딧이 모두 소진됐어요. 내일 다시 접속하시면 데일리 보너스를 받을 수 있어요.',
  // 크레딧 1개 = 생성 이미지 1장이라 사진 N장은 N개가 든다.
  creditCostHint: '사진 {n}장은 크레딧 {c}개를 써요 — 한 장에 {p}개씩이에요.',
  errCreditsShort: '크레딧 {need}개가 필요한데 지금 {have}개예요. 사진을 줄이거나, 친구를 초대해 더 받아 보세요.',

  // Credits
  credits: '크레딧',
  creditsOne: '{n} 크레딧',
  creditsMany: '{n} 크레딧',
  outOfCredits: '크레딧이 모두 소진됐어요',
  creditModalTitle: '크레딧 더 받기',
  creditModalDesc: '내일이면 무료 크레딧이 다시 채워져요. 그 전에 더 필요하다면요?',
  creditModalWallDesc: '오늘 무료는 다 썼어요. 내일 {n}장이 다시 채워져요 — 지금 바로 이어서 만들려면 충전하세요.',
  errOutOfCreditsToday: '오늘 크레딧을 다 썼어요. 내일 무료 {n}장이 다시 채워져요 — 지금 이어서 만들려면 충전하세요.',
  lastFreeHint: '오늘 무료 마지막 장이었어요. 내일 {n}장이 다시 채워져요.',
  lastFreeHintCta: '지금 충전',
  creditModalChatFree: '디자이너 Gio 와의 대화는 계속 무료예요.',
  creditModalGuestTitle: '계속 만들려면 로그인이 필요해요',
  creditModalGuestDesc: '로그인하면 매일 무료 크레딧을 받고 저장·공유도 할 수 있어요.',
  creditOptionSignIn: '로그인하고 계속 만들기',
  creditOptionSignInDesc: 'Google 또는 Apple 계정으로 1초 만에 시작',
  creditOptionInvite: '친구 초대하기',
  creditOptionInviteDesc: '친구가 가입하면 두 사람 모두 +{n} 크레딧',
  comingSoon: '곧 출시 예정',
  close: '닫기',
  getAppTitle: 'archelier',
  getAppDesc: '앱에서 내 공간을 바꿔보세요',
  getAppCta: '받기',
  appGateTitle: '앱에서 이어가기',
  appGateDesc: '디자인은 앱이 편해요. 카메라, 보관함, 더 빠른 결과까지.',
  appGateCta: '앱 받기',
  appGateNotNow: '나중에',
  dailyBonusHint: '매일 무료 크레딧 {n}개를 드려요.',
  creditsAria: '남은 크레딧 {n}개',
  accountCreditsTitle: '크레딧',
  creditsDailyLabel: '매일 충전, 자정 초기화',
  creditsBonusLabel: '보너스, 소멸 없음',
  creditsResetHint: '매일 무료 크레딧 {n}개를 드려요. 초대로 받은 보너스 크레딧은 쓸 때까지 그대로 남아요.',
  creditsInviteCta: '친구 초대하고 +{n} 받기',
  creditsTopUpCta: "크레딧 충전",
  inviteMenu: '친구 초대',
  profileShare: '공유',
  profileShareText: 'archelier 에서 {name} 님의 디자인을 구경해보세요.',

  // Result step
  original: '원본',
  aiDesign: 'AI 디자인',
  imageGenFailed: '이 사진의 이미지 생성에 실패했어요',
  seeAnalysis: '아래 디자인 분석을 확인해주세요.',
  analysisTitle: '인테리어 디자인 분석',
  spaceAnalysis: '공간 분석',
  styleDescription: '스타일 설명',
  colorPalette: '컬러 팔레트',
  furnitureRec: '가구 추천',
  shopFor: '{item} 쇼핑 검색',
  shopShort: '쇼핑',
  paintMatch: '가장 가까운 페인트',
  paintCodeCopy: '페인트 코드 복사',
  paintCodeCopied: '코드 복사됨',
  editRegion: '부분 편집',
  editRegionTitle: '부분 편집',
  editRegionDesc: 'AI 에게 무엇을 바꿀지, 무엇으로 바꿀지 알려주세요. 나머지는 그대로 유지돼요.',
  editRegionBrushHint: '무엇을 바꾸거나 더할지 적어 주세요. 한 곳만 바꾸려면 먼저 그 자리를 칠하고, 칠하지 않으면 사진 전체에서 말한 대로 고쳐요. 없애고 싶으면 칠한 뒤 “없애줘” 라고 적으면 돼요.',
  editRegionMeta: '새 디자인으로 저장 · 크레딧 {n}개',
  editedFromBanner: '이 디자인은 부분 편집된 사본이에요.',
  viewOriginal: '원본 보기',
  editsOfThisDesign: '이 디자인의 편집본',
  editsOfThisDesignDesc: '이 디자인의 일부를 바꿔 만든 새 디자인들이에요.',
  chatTitle: 'AI 디자인 어드바이저',
  chatHint: '이 방에 대해 더 물어보세요. AI 가 디자인을 보면서 답해줘요.',
  chatStart: '대화 시작',
  chatPlaceholder: '가구 / 색상 / 배치에 대해 물어보세요…',
  chatSend: '보내기',
  chatSending: '생각 중…',
  chatSuggestion1: '이 방을 따뜻하게 하려면 어떤 조명이 좋을까?',
  chatSuggestion2: '더 넓어 보이게 하려면?',
  chatSuggestion3: '먼저 바꿔야 할 3가지는?',
  chatTurnsRemaining: '이 디자인에 {n}턴 남음',
  chatTurnsExhausted: '이 디자인의 대화 한도에 도달했어요. 새 디자인을 만들면 다시 이어갈 수 있어요.',
  chatErrGeneric: '어드바이저가 답변을 못 했어요. 다시 시도해주세요.',
  chatPro: 'Pro — 무제한 챗',
  chatRetry: '다시 시도',
  commentsTitle: '댓글',
  commentPlaceholder: '댓글을 남겨주세요',
  commentPost: '게시',
  commentPosting: '게시 중…',
  commentSignInHint: '로그인하면 댓글을 남길 수 있어요.',
  commentEmpty: '아직 댓글이 없어요.',
  commentDelete: '삭제',
  commentDeleteConfirm: '이 댓글을 삭제할까요?',
  commentTooLong: '댓글은 500자까지만 가능해요.',
  commentErrGeneric: '댓글 게시에 실패했어요. 다시 시도해주세요.',
  commentCount: '{n}',
  bookmarksTitle: '내 컬렉션',
  // MyTabs sub-tab 전용 — 이미 My 허브 안이라 "내 ..." 중복.
  tabDesigns: '디자인',
  tabCollections: '컬렉션',
  bookmarksSectionTitle: '북마크한 디자인',
  bookmarksEmpty: '아직 컬렉션이 없어요. 마음에 드는 디자인을 저장하면 보드가 만들어져요.',
  bookmarksAdd: '저장',
  bookmarksAdded: '저장됨',
  bookmarksRemove: '저장에서 제거',
  bookmarksSignInHint: '로그인하면 디자인을 저장할 수 있어요.',
  saved: '저장됨',
  savedCollectionDefault: '저장함',
  follow: '팔로우',
  unfollow: '언팔로우',
  following: '팔로잉',
  followers: '팔로워',
  followingTab: '팔로잉',
  followingEmpty: '팔로우한 사람의 최신 디자인을 여기서 볼 수 있어요.',
  followersEmpty: '아직 팔로워가 없어요.',
  followingEmpty2: '아직 팔로우 중인 사람이 없어요.',
  followSignInHint: '로그인하면 팔로우할 수 있어요',
  cannotFollowSelf: '본인을 팔로우할 수 없어요.',
  profile: '프로필',
  profileNotFound: '존재하지 않는 프로필이에요.',
  profileDesigns: '디자인',
  profileDesignsCount: '디자인',
  profileFollowers: '팔로워',
  profileFollowing: '팔로잉',
  profileBio: '소개',
  profileEdit: '프로필 편집',
  profileMyProfile: '내 프로필',
  displayNameLabel: '표시 이름',
  displayNamePlaceholder: '이름 또는 스튜디오명 (선택)',
  displayNameSave: '이름 저장',
  displayNameSaved: '이름 저장됨',
  displayNameErrGeneric: '이름 저장에 실패했어요. 다시 시도해주세요.',
  handleLabel: '핸들',
  handlePlaceholder: '소문자, 숫자, 밑줄 (3-20자)',
  handleSave: '핸들 저장',
  handleSaved: '핸들 저장됨',
  handleInvalid: '핸들은 3-20자, a-z / 0-9 / _ 만 가능해요.',
  handleTaken: '이미 사용 중인 핸들이에요.',
  handleErrGeneric: '핸들 저장에 실패했어요. 다시 시도해주세요.',
  bioPlaceholder: '간단한 소개 (200자 이내)',
  bioSave: '소개 저장',
  bioSaved: '소개 저장됨',
  bioErrGeneric: '소개 저장에 실패했어요. 다시 시도해주세요.',
  instagramLabel: '인스타그램',
  instagramPlaceholder: '인스타 아이디',
  instagramInvalid: '영문·숫자·마침표·언더스코어만, 최대 30자.',
  profileNoDesigns: '아직 디자인이 없어요.',
  collections: '컬렉션',
  collectionsTab: '컬렉션',
  collectionMine: '내 컬렉션',
  collectionEmpty: '아직 컬렉션이 없어요.',
  collectionPublicEmpty: '공개 컬렉션이 없어요.',
  collectionItemCount: '{n}개',
  collectionEmpty2: '이 컬렉션은 비어있어요.',
  newCollection: '새 컬렉션',
  collectionNamePlaceholder: '컬렉션 이름 (예: 거실 영감)',
  collectionCreate: '만들기',
  collectionDelete: '컬렉션 삭제',
  collectionDeleteConfirm: '이 컬렉션을 삭제할까요? 모든 아이템이 제거돼요.',
  collectionRename: '컬렉션 이름 변경',
  collectionVisibility: '공개 컬렉션',
  collectionVisibilityOn: '링크가 있는 누구나 볼 수 있어요',
  collectionVisibilityOff: '나만 볼 수 있어요',
  addToCollection: '컬렉션에 추가',
  saveToCollection: '컬렉션에 저장',
  collectionAdded: '추가됨',
  collectionRemoveFromBoard: '컬렉션에서 제거',
  collectionShareLink: '컬렉션 링크 복사',
  collectionByOwner: 'by',
  collectionNotFound: '존재하지 않거나 비공개 컬렉션이에요.',
  collectionErrCreate: '컬렉션 만들기에 실패했어요.',
  collectionErrSave: '컬렉션 업데이트에 실패했어요.',
  collectionDone: '확인',
  collectionPickerHint: '컬렉션을 탭해서 디자인을 추가하거나 제거하세요.',
  uploadAcceptsHint: '사진이 제일 잘 나와요. 손그림 스케치, 입면도, 평면도, 3D 모델 스크린샷도 OK.',
  examplePhotos: '예시 사진',
  detectedInputTypes: {
    sketch: '스케치',
    elevation: '입면도',
    floorplan: '평면도',
    '3d_model': '3D 모델',
  },
  floorplanDetectedBanner: '평면도로 인식했어요. 가장 큰 공용 공간을 사람 시점으로 렌더했어요. 다른 방을 보고 싶으면 다음번에 추가 요청에 「안방으로」 처럼 적어주세요.',
  floorplanDetectedBannerWithRoom: '평면도로 인식했어요. {room}을(를) 사람 시점으로 렌더했어요. 다른 방을 보고 싶으면 다음번에 추가 요청에 적어주세요.',
  spaceCategoryTitle: '어떤 공간을 디자인할까요?',
  spaceCategories: {
    interior: '실내',
    exterior: '외관',
    garden: '정원',
  },
  exteriorStyles: {
    halloween: { name: '할로윈', description: '호박 장식, 등, 어둑한 가을 현관' },
    christmas: { name: '크리스마스', description: '리스, 따뜻한 전구, 상록 갈란드' },
    lunar_new_year: { name: '설날', description: '홍등, 금색 장식, 길상 문구' },
    spring_blossom: { name: '봄 벚꽃', description: '꽃나무, 파스텔 화단, 맑은 봄볕' },
    modern_facade:        { name: '모던 파사드',        description: '깔끔한 기하학, 큰 유리창, 혼합 마감재' },
    modern_farmhouse:     { name: '모던 팜하우스',      description: '화이트 사이딩, 블랙 트림, 나무 포인트' },
    mediterranean:        { name: '지중해식',           description: '스투코, 테라코타, 아치형 개구부' },
    craftsman:            { name: '크래프츠맨',         description: '나무 슁글, 낮은 박공, 노출 서까래' },
    contemporary:         { name: '컨템퍼러리',         description: '날카로운 라인, 대담한 볼륨, 산업재' },
    minimalist_exterior:  { name: '미니멀리스트 외관',   description: '절제된 팔레트, 단일 재료 강조' },
    tudor:                { name: '튜더',               description: '하프팀버 외벽 + 가파른 박공의 영국식' },
    cape_cod:             { name: '케이프 코드',         description: '뉴잉글랜드 전통 — 흰 슁글에 검정 셔터' },
    japanese_traditional: { name: '일본 전통가옥',        description: '민가풍 목조 + 기와 + 엔가와' },
    mountain_cabin:       { name: '산속 캐빈',           description: '통나무 또는 A프레임, 자연 속 산장' },
    midcentury_exterior:  { name: '미드센추리 외관',      description: '1950–60년대 모더니즘 — 평지붕, 큰 유리, 가로 라인' },
  },
  gardenStyles: {
    halloween: { name: '할로윈', description: '호박밭, 등, 안개 낀 가을 정원' },
    christmas: { name: '크리스마스', description: '불 밝힌 상록수, 따뜻한 조명, 겨울 정원' },
    lunar_new_year: { name: '설날', description: '홍등, 매화 가지, 길상의 정원' },
    spring_blossom: { name: '봄 벚꽃', description: '벚꽃, 튤립, 싱그러운 봄 초록' },
    modern:         { name: '모던 가든', description: '정돈된 기하, 콘크리트 포장, 그라스' },
    mediterranean:  { name: '지중해', description: '자갈, 올리브와 라벤더, 테라코타 화분' },
    coastal:        { name: '해안', description: '억새, 유목, 내염성 식재' },
    minimalist:     { name: '미니멀', description: '한 가지 재료와 식재, 여백' },
    zen:      { name: '젠 가든',         description: '갈퀴질한 자갈, 돌, 절제된 식물' },
    cottage:  { name: '코티지 가든',      description: '낭만적, 다년생 식물 가득' },
    desert:   { name: '사막 / 제리스케이프', description: '내건성 식물, 다육이, 자갈' },
    tropical: { name: '트로피컬',         description: '울창한 잎, 큰 잎사귀, 강렬한 꽃' },
    english:  { name: '잉글리시 가든',    description: '잘 정돈된 잔디, 헤지, 레이어드 화단' },
  },
  seasonLabel: '계절',
  seasons: {
    none: '아무 때나',
    spring: '봄',
    summer: '여름',
    autumn: '가을',
    winter: '겨울',
  },
  timeOfDayLabel: '시간대',
  timesOfDay: {
    none: '아무 때나',
    day: '대낮',
    golden_hour: '골든아워',
    night: '밤',
  },
  editRegionReplacementLabel: '무엇을 할까요?',
  editRegionReplacementPlaceholder: '예: 현관 옆에 큰 동상을 추가해줘',
  editRegionSubmit: '편집 생성',
  editRegionGenerating: '편집된 이미지를 생성하고 있어요…',
  editRegionMaskRequired: '먼저 바꾸고 싶은 영역을 칠해주세요.',
  editRegionReplacementRequired: '무엇으로 바꿀지 알려주세요.',
  editRegionBrush: '브러시',
  editRegionUndo: '되돌리기',
  editRegionSize: '굵기',
  editRegionClear: '리셋',
  errEditGeneric: '편집에 실패했어요. 다시 시도해주세요.',
  lightingPlan: '조명 계획',
  designTips: '디자인 팁',
  startNew: '새 디자인 시작',
  viewMyDesigns: '나의 디자인 보기',
  favorite: '즐겨찾기',
  unfavorite: '즐겨찾기에서 제거',
  rename: '이름 변경',
  savePromptText: '가입하면 이 디자인을 저장해 두고, 공유하고, 더 만들 수 있어요',
  guestCreditsLeft: '무료 체험 {n}번 남았어요. 가입하면 {total}개로 시작해요.',
  guestCreditsGone: '무료 체험을 다 썼어요. 가입하면 {total}개 드려요.',
  signInGoogle: 'Google로 로그인',
  signInApple: 'Apple로 로그인',
  signInDesc: '디자인을 저장하고 언제든지 다시 볼 수 있어요.',
  signInPopupBlocked: '팝업이 차단되었습니다. 브라우저 설정에서 팝업을 허용해주세요.',

  // Header / mobile nav
  appName: 'archelier',
  navCreate: '만들기',
  navGallery: '갤러리',
  navGio: '디자이너',
  navMain: '주요 메뉴',
  packsTitle: "바로 충전",
  packDesigns: "디자인 약 {n}장",
  packBuying: "여는 중…",
  packWaiting: "결제 완료 — 크레딧을 넣는 중이에요…",
  packDone: "크레딧이 들어왔어요.",
  packSlow: "크레딧이 곧 들어와요. 다시 구매하지 않으셔도 돼요.",
  packFailed: "결제가 완료되지 않았어요. 결제됐는데 크레딧이 안 들어오면 문의해 주세요.",
  gioRole: "공간 디자이너",
  gioAiNote: "AI",
  gioSignInBody: "로그인하면 Gio 와 대화할 수 있어요. 방 사진과 지금까지 만든 디자인을 보고 스타일을 추천하고, 대화에서 바로 만들거나 고쳐 드려요.",
  gioGreeting: "안녕하세요, Gio 예요. 공간 사진이나 마음에 드는 방 사진·링크, 아니면 만들어 둔 디자인을 보내 주세요. 어울리는 방향을 제안하고 바로 만들어 드릴게요.",
  gioChipTaste: "내 취향 분석해줘",
  gioChipTrend: "이번 주 뜨는 스타일은?",
  gioChipPhoto: "방 사진 보내기",
  gioChipMine: "내 디자인 불러오기",
  gioTyping: "Gio 가 생각하고 있어요…",
  gioPlaceholder: "Gio 에게 물어보거나 링크를 붙여 넣으세요",
  gioSend: "보내기",
  gioAttachPhoto: "사진 첨부",
  gioPickDesign: "내 디자인",
  gioPickEmpty: "아직 디자인이 없어요. 먼저 하나 만들고 불러와 주세요.",
  gioRemove: "빼기",
  gioToday: "오늘",
  gioNoCredits: "크레딧이 다 떨어졌어요.",
  gioError: "지금 Gio 가 답하지 못했어요. 다시 보내 주세요.",
  gioAlreadyStarting: "이미 시작하는 중이에요. 잠시만요.",
  gioPhotoSkipped: "일부 사진을 추가하지 못했어요. 최대 {n}장까지 첨부할 수 있어요 (JPG, PNG, WebP 또는 HEIC, 20MB 이하).",
  gioErrPhotos: "사진을 찾을 수 없어요. 공간 사진을 추가하고 다시 시도해 주세요.",
  gioErrPrompt: "Gio가 디자인으로 변환하지 못했어요. 조금 다르게 설명해 보세요.",
  gioErrGone: "해당 디자인이나 제안은 더 이상 이용할 수 없어요.",
  gioCreditsLow: "크레딧 {n} 남음 · 메시지 {c}, 사진이 붙으면 {p}",
  gioCreditsLowFree: "크레딧 {n} 남음 · 대화는 무료예요",
  gioNoCreditsChatFree: "만들 크레딧은 다 떨어졌어요 — 대화는 계속 무료예요.",
  gioDailyLimit: "오늘은 대화를 많이 나눴어요. 내일 이어서 이야기해요.",
  gioCardEdit: "수정",
  gioCardPhotos: "사진 {n}장",
  gioCardPhotoFromDesign: "{date} 디자인의 사진",
  gioCardPhotoFromDesignNoDate: "예전 디자인의 사진",
  gioCardPhotoFromChat: "대화에 올린 사진",
  gioCardPhotoNew: "새 사진",
  gioCardNoPhoto: "아직 사진이 없어요",
  gioCardChangePhoto: "바꾸기",
  gioCardAddPhoto: "사진 넣기",
  gioCardUploading: "올리는 중…",
  gioCardSame: "이 사진으로 만든 {style} 디자인이 이미 있어요 ({date}).",
  gioCardSameView: "보기",
  gioCardSameHint: "추가 요청 사항이 같으면 거의 비슷하게 나와요. 다르게 하려면 위에 추가 요청 사항을 넣거나, 대화로 Gio 에게 말하거나, 만들기 화면에서 열어 고쳐 보세요.",
  gioPickPhoto: "사진 고르기",
  gioPickUpload: "새 사진 올리기",
  gioRunEdit: "수정하기 · {n} 크레딧",
  gioRunGenerate: "만들기 · {n} 크레딧",
  gioRunWithPhoto: "사진 넣고 만들기 · 장당 {n}",
  gioOpenInCreate: "만들기 화면에서",
  gioPaintMyself: "직접 칠하기",
  gioStarting: "시작하는 중…",
  gioJobMaking: "디자인을 만들고 있어요…",
  gioJobEditing: "디자인을 고치고 있어요…",
  gioJobNotify: "다른 화면으로 가셔도 돼요. 끝나면 알려 드릴게요.",
  gioJobInvalid: "디자인할 수 있는 공간 사진이 아닌 것 같아요.",
  gioJobFailed: "이번 건 완성하지 못했어요.",
  gioJobRefunded: "크레딧은 돌려드렸어요.",
  gioJobDone: "완성됐어요 — 보러 가기",
  gioJobGone: "삭제된 디자인이에요.",
  gioAskAboutDesign: "Gio 에게 이 디자인 물어보기",
  navFeed: '피드',
  navMy: '내 페이지',
  navAccount: '설정',
  signIn: '로그인',
  signOut: '로그아웃',
  deleteAccount: '계정 삭제',
  deleteAccountTitle: '계정을 삭제하시겠습니까?',
  deleteAccountWarn: '계정과 연결된 모든 데이터가 영구적으로 삭제됩니다. 되돌릴 수 없습니다.',
  deleteAccountItem_designs: '모든 디자인과 이미지, Gio 와 나눈 대화',
  deleteAccountItem_profile: '프로필, 핸들, 저장된 스타일',
  deleteAccountItem_social: '댓글, 좋아요, 팔로우, 컬렉션',
  deleteAccountItem_credits: '남은 크레딧(구매한 크레딧 포함)과 구독 내역',
  deleteAccountBilling_web: '웹 구독은 자동으로 함께 취소됩니다.',
  deleteAccountBilling_ios: 'App Store · Google Play 구독은 자동 취소되지 않습니다. 스토어의 구독 설정에서 직접 취소해 주세요.',
  deleteAccountFinal: '즉시 로그아웃되며 이 계정은 다시 복구할 수 없습니다.',
  deleteAccountConfirm: '계정 삭제',
  deleteAccountSubmitting: '삭제 중…',
  deleteAccountError: '계정을 삭제하지 못했습니다. 다시 시도해 주세요.',
  myDesigns: '내 디자인',
  language: '언어',
  support: '지원',
  deleteAccount: '계정 삭제',
  terms: '이용약관',
  privacy: '개인정보처리방침',
  signInTerms: '로그인하면 {terms} 및 {privacy}에 동의하게 됩니다.',

  // Onboarding
  onboardingSkip: '건너뛰기',
  onboardingNext: '다음',
  onboardingStart: '시작하기',
  tourTitle: 'archelier 둘러보기',
  tourCreate: '여기서 시작해요. 방·외관·정원 사진을 찍거나 올리고 스타일을 고르면 잠시 뒤 새 디자인이 나와요.',
  tourGallery: '갤러리예요. 이번 주 archelier 에서 많이 고른 스타일이 모여 있고, 눌러서 내 공간에 바로 써 볼 수 있어요.',
  tourGio: '디자이너 Gio 예요. 사진을 보여주고 원하는 걸 말하면 스타일을 추천하고 디자인을 만들거나 고쳐줘요.',
  tourMy: '만든 디자인은 내 페이지에 모여요. 원하는 부분만 칠하거나 말로 고칠 수 있고, 다운로드·공유도 여기서 해요.',
  tourStart: '새 디자인은 언제든 이 버튼으로 만들어요. 사진 한 장으로 시작해 볼까요?',
  tourReplay: '둘러보기 다시 보기',
  onboarding: [
    {
      icon: 'photo_camera',
      title: '사진·스케치·도면 다 OK',
      desc: '핸드폰 사진이 가장 잘 되지만, 손그림 스케치, 입면도, 평면도, 3D 모델 캡쳐도 자동으로 인식해요.',
    },
    {
      icon: 'style',
      title: '19+ 스타일과 4가지 모드',
      desc: '프리셋 스타일, 직접 묘사한 커스텀, 마음에 드는 사진과 비슷한 톤(레퍼런스), 정리(Cleanup) 또는 가구 재배치(Layout) 모드까지.',
    },
    {
      icon: 'brush',
      title: '일부만 다시 그리기',
      desc: '한 부분만 바꾸고 싶으면 결과 위에 칠하고 무엇으로 바꿀지 알려주세요. 나머지는 픽셀 그대로 유지돼요.',
    },
    {
      icon: 'auto_awesome',
      title: '지금 바로 만들어보세요',
      desc: '매일 무료 크레딧을 드려요. 사진을 올리면 1분 안에 첫 디자인이 완성돼요.',
    },
  ],

  // 모바일 spotlight 온보딩 — 탭 하나씩 짧게.
  onboardTabFeedTitle: '먼저 둘러보세요',
  onboardTabFeedDesc: '다른 사람이 만든 공간을 구경하면서 영감을 받아보세요.',
  onboardTabCreateTitle: '내 공간을 AI 로',
  onboardTabCreateDesc: '사진·스케치·도면을 올리면 AI 가 새로운 디자인을 만들어줘요.',
  onboardTabMyTitle: '저장하고 관리',
  onboardTabMyDesc: '만든 디자인은 여기에 모이고, 피드로 공유하거나 다운로드할 수 있어요.',
  onboardTabGioTitle: "Gio 에게 물어보기",
  onboardTabGioDesc: "공간 디자이너 Gio 가 사진을 보고 스타일을 추천하고, 대화에서 바로 만들거나 고쳐 드려요.",

  // My Designs page
  myDesignsTitle: '내 디자인',
  signInToSee: '로그인하면 저장된 디자인을 볼 수 있어요',
  signInToSeeDesc: '저장된 디자인이 여기에 표시돼요.',
  loadingDesigns: '디자인 불러오는 중…',
  errLoadDesigns: '디자인을 불러오지 못했어요. 다시 시도해주세요.',
  retry: '다시 시도',
  noFavorites: '즐겨찾기한 디자인이 없어요.',
  noDesigns: '아직 디자인이 없어요. 첫 번째 디자인을 만들어보세요!',
  createDesign: '디자인 만들기',
  loadMore: '더 보기',

  // Design detail
  loading: '불러오는 중…',
  errDesignNotFound: '디자인을 찾을 수 없어요.',
  errLoadDesign: '디자인을 불러오지 못했어요.',
  errDeleteDesign: '삭제에 실패했어요. 다시 시도해주세요.',
  renameTitle: '이름 변경',
  // rename 모달 placeholder — 하나만 두면 다들 그 문구를 그대로 쓴다.
  // 열 때마다 무작위로 하나 고른다 (공간 종류·버전 표기를 섞어 둬서
  // "이렇게 편하게 적으면 된다" 가 읽히게).
  renamePlaceholders: [
    '거실 리모델링 1안',
    '주방 — 밝은 버전',
    '작업실 개조',
    '침실, 따뜻한 톤',
    '베란다 B안',
    '서재 세팅',
    '카페 인테리어 초안',
    '앞마당 2안',
  ],
  save: '저장',
  cancel: '취소',
  deleteTitle: '디자인 삭제?',
  deleteDesc: '이 디자인과 모든 이미지가 영구적으로 삭제돼요. 이 작업은 되돌릴 수 없어요.',
  delete: '삭제',
  deleting: '삭제 중…',
  postToFeed: '피드에 올리기',
  postedToFeedTitle: '피드에 올렸어요',
  postedToFeedDesc: '이제 다른 사용자들도 피드에서 이 디자인을 보고 좋아요를 누를 수 있어요.',
  captionTitle: '한 마디 남기기',
  captionPlaceholder: '왜 이 공간을 새로 디자인하고 싶었는지 들려주세요 (선택)',
  captionEdit: '글 수정',
  captionPost: '올리기',
  captionSave: '저장',
  captionCancel: '취소',
  viewFeed: '피드 보기',
  generationInProgress: '디자인을 만들고 있어요…',
  generationKeepBrowsing: '다른 페이지를 둘러봐도 돼요. 완성되면 알려드릴게요',
  generationDone: '디자인이 완성됐어요!',
  generationTapToOpen: '「열기」를 누르면 결과를 볼 수 있어요',
  generationFailed: '생성 실패',
  generationFailedHint: '크레딧은 차감되지 않았어요. 다시 시도해 주세요.',
  open: '열기',
  tryAgain: '다시 시도',
  copy: '복사',
  copied: '복사됨!',
  share: '공유',
  downloadImages: 'AI 이미지 다운로드',
  download: '다운로드',
  downloadWatermarkHint: '이미지 오른쪽 아래에 작게 archelier 서명이 들어가요.',
  modes: {
    redesign: '재디자인',
    staging: '빈 방 스테이징',
  },
  styleUsed: '사용한 스타일',
  customDescLabel: '커스텀 설명:',
  additionalReqLabel: '추가 요청 사항:',
  useStyleAgain: '이 스타일로 다시 시도',

  // Community feed
  feedTitle: '커뮤니티',
  feedEmpty: '아직 공개된 디자인이 없어요. 첫 번째가 되어보세요!',
  feedSortLatest: '최신순',
  feedSortPopular: '인기순',
  feedFilterAll: '전체',
  useThisStyle: '이 스타일로 시작하기',
  sourceDesignBanner: '"{name}" 디자인을 참고하고 있어요',
  galleryPickBanner: '{name} 스타일로 만들어요',
  signInToLike: '좋아요를 누르려면 로그인하세요',

  // Share view
  tryApp: 'archelier 써보기',
  privateTitle: '비공개 디자인이에요',
  privateDesc: '이 디자인은 아직 공개되지 않았어요.',
  linkNotFoundTitle: '링크를 열 수 없어요',
  linkNotFoundDesc: '디자인이 삭제되었거나 링크가 잘린 것 같아요.',
  createWithApp: 'archelier으로 디자인 만들기',
  shareViewCTA: '내 공간도 리디자인해보고 싶으신가요?',

  // Interior styles
  styles: {
    modern:       { name: '모던',              description: '깔끔한 선, 중립적인 톤, 현대적 미니멀리즘' },
    scandinavian: { name: '스칸디나비안',       description: '밝고 자연적인 소재, 포근한 북유럽 감성' },
    ikea:         { name: 'IKEA',              description: '실용적이고 접근하기 쉬운 스칸디나비아 일상 디자인' },
    japandi:      { name: '재팬디',             description: '일본 미니멀리즘과 스칸디나비안 온기의 조화' },
    industrial:   { name: '인더스트리얼',       description: '원재료, 노출 요소, 도시적 로프트 미학' },
    coastal:      { name: '코스탈',             description: '상쾌하고 빛이 가득한 해안 별장 감성' },
    classic:      { name: '클래식',             description: '시대를 초월한 우아함, 고급 패브릭, 장식적인 디테일' },
    artdeco:      { name: '아르 데코',          description: '대담한 기하학, 골드 포인트, 1920년대 화려함' },
    midcentury:   { name: '미드 센추리 모던',   description: '유기적인 형태, 따뜻한 원목, 1950~60년대 레트로 감성' },
    maximalist:   { name: '맥시멀리스트',       description: '대담한 패턴, 풍부한 레이어링, 더 많을수록 더 좋다' },
    vintage:      { name: '빈티지',             description: '향수를 자극하는 매력, 앤티크 소품, 따뜻한 레트로 팔레트' },
    bohemian:     { name: '보헤미안',           description: '자유로운 영혼, 컬러풀한 텍스타일, 예술적 절충주의' },
    tropical:     { name: '트로피컬',            description: '울창한 식물, 라탄, 시원한 리조트 감성' },
    cottagecore:  { name: '코티지코어',           description: '영국 시골 로맨틱, 플로럴, 부드러운 파스텔' },
    rustic:       { name: '러스틱',              description: '거친 원목, 돌, 따뜻한 팜하우스 감성' },
    wabisabi:     { name: '와비사비',            description: '불완전한 아름다움, 거친 질감, 조용한 일본적 절제' },
    gothic:       { name: '고딕',                description: '어두운 드라마, 벨벳, 화려한 실루엣' },
    cyberpunk:    { name: '사이버펑크',           description: '네온 미래주의, 하이테크 표면, 도시 디스토피아' },
    taisho_romance: { name: '다이쇼 로망',        description: '20세기 초 일본과 서양 아르누보의 절충 미학' },
    biophilic:    { name: '바이오필릭',           description: '식물 가득, 자연광, 유기적 텍스처' },
    cozy:         { name: '코지',                description: '따뜻하고 부드러운 휘게(hygge) 감성' },
    gaming:       { name: '게이밍',              description: 'RGB 셋업, 매끈한 테크, 몰입형 배틀스테이션' },
    minimalist:     { name: '미니멀', description: '덜어낸 구성, 여백 위주' },
    mediterranean:  { name: '지중해', description: '라임워시 벽, 테라코타, 아치, 석재' },
    luxury:         { name: '콰이어트 럭셔리', description: '고급 소재, 절제된 색, 과시 없는' },
    dark_academia:  { name: '다크 아카데미아', description: '서재풍 — 버건디, 황동, 쌓인 책' },
    organic_modern: { name: '오가닉 모던', description: '모던한 형태에 날것의 자연 소재' },
    farmhouse:      { name: '팜하우스', description: '널빤지 벽, 에이프런 싱크, 낡은 나무' },
    halloween:      { name: '할로윈', description: '호박, 촛불, 어둑한 가을빛' },
    christmas:      { name: '크리스마스', description: '트리, 갈란드, 따뜻한 조명' },
    lunar_new_year: { name: '설날', description: '홍금색, 등, 길상 문양' },
    spring_blossom: { name: '봄 벚꽃', description: '벚꽃, 파스텔, 맑은 봄볕' },
    custom:       { name: '커스텀 스타일',      description: '나만의 독특한 인테리어 비전을 직접 설명하세요' },
    reference:    { name: '레퍼런스',           description: '마음에 드는 사진의 톤·소재·분위기를 그대로 적용해요' },
    floorplan:    { name: '평면도', description: '3D 평면도나 깔끔한 도면으로 바꿔 줘요' },
    cleanup:      { name: '정리',                description: '잡동사니만 정리하거나 빈 방으로 — 선택할 수 있어요' },
    layout:       { name: '배치',                description: '가구 그대로, 위치만 — 동선 또는 시원하게' },
  },

  langMismatchNotice: '이 분석은 {lang}로 생성되었습니다.',

  // Pricing page
  pricingTitle: '필요에 맞게 선택하는 플랜',
  pricingSubtitle: '무료로 시작하고, 더 많은 생성이 필요할 때 업그레이드하세요.',
  pricePerMonth: '/ 월',
  trialCta: '{n}일 무료 체험 시작',
  accountPlanFreeTitle: '현재 무료 플랜이에요',
  accountPlanProTitle: 'Pro 사용 중',
  accountPlanTrialTitle: 'Pro 무료 체험 중',
  proTrialBadge: '체험판',
  proTrialDaysLeft: '무료 체험 {n}일 남음',
  proTrialIntroTitle: '2주간 Pro 무료 체험',
  proTrialIntroDesc: '가입하면 무료 크레딧 {n}개로 시작해요.',
  proTrialFeatures: '그다음엔 매일 {n}개씩 더. 구독은 없어요.',
  welcomeSkip: '계정 없이 계속',
  // Marketing landing (/landing)
  landingHeadline: '어떤 공간이든, 몇 초 만에 새 디자인.',
  landingTagline: '사진 한 장으로 스타일을 골라 포토리얼 인테리어 렌더를 받아보세요. 매일 무료, 구독 없음.',
  landingOpenWeb: '웹에서 계속하기 →',
  landingFeat1: 'AI 인테리어 렌더',
  landingFeat2: '포토리얼',
  landingFeat3: '50+ 스타일',
  landingFeat4: '정원·외관',
  landingFeat5: '매일 무료',
  landingStoreOn: '다운로드',
  landingStoreGet: '다운로드',
  // 랜딩 본문 (lp.*) — en.js 의 lp 와 같은 키. 언어별 정적 페이지(/ko)·JSON-LD 원본.
  lp: {
    metaTitle: 'archelier — 사진 한 장으로 AI 인테리어 디자인',
    metaDescription: '방 사진 한 장이면 약 1분 만에 포토리얼 리디자인. 실내·외관·정원 48가지 스타일, 3D 평면도, 부분 편집, 대화하며 함께 고르는 AI 디자이너까지. 매일 무료.',
    heroEyebrow: 'AI 인테리어 디자인',
    scrollCue: '어떻게 되는지 보기',
    webCta: '브라우저에서 무료로 해보기',
    orApp: '앱으로 받기',
    qrHint: '폰 카메라로 찍어 보세요. 앱은 디자인이 완성되는 순간 알려 드려요.',
    showEyebrow: '비포 & 애프터',
    showTitle: '사진 한 장, 완전히 새로운 방.',
    showBody: 'archelier 로 만든 실제 결과입니다. 끌어서 비교해 보세요.',
    before: '전',
    after: '후',
    tabRoom: '거실',
    tabEmpty: '빈 방',
    tabSketch: '스케치',
    tabPlan: '평면도',
    tabExterior: '외관',
    capRoom: '러스틱 — 같은 주방과 거실을 더 따뜻하게.',
    capEmpty: '스칸디나비안 — 빈 방에 가구를 채웠습니다.',
    capSketch: '재팬디 — 선 스케치를 실제 공간처럼.',
    capPlan: '평면도 모드 — 2D 평면도를 집 전체 3D 뷰로.',
    capExterior: '미니멀 — 복잡한 가게 외관을 새로.',
    howEyebrow: '사용 방법',
    howTitle: '세 단계, 약 1분.',
    how1Title: '사진 찍기',
    how1Body: '지금 모습 그대로의 방 — 또는 스케치, 평면도, 3D 화면 캡처. 같은 방을 최대 3장까지.',
    how2Title: '스타일 고르기',
    how2Body: '48가지 스타일 중에서 고르거나, 한 문장으로 직접 설명하거나, 마음에 드는 사진을 올리세요.',
    how3Title: '디자인 받기',
    how3Body: '내 공간의 포토리얼 렌더와 함께 가구 목록, 컬러 팔레트, 조명 계획까지.',
    stylesEyebrow: '스타일',
    stylesTitle: '세 가지 공간, 48가지 스타일.',
    stylesBody: '실내 28, 외관 11, 정원 9 — 그리고 할로윈·크리스마스·설날·봄 시즌 스타일.',
    stylesInterior: '실내',
    stylesExterior: '외관',
    stylesGarden: '정원',
    stylesCta: '스타일 갤러리 보기',
    modesEyebrow: '스타일 그 너머',
    modesTitle: '공간을 다루는 다섯 가지 방법.',
    modeCustomTitle: '나만의 스타일',
    modeCustomBody: '원하는 느낌을 한 문장으로 적고, 다음에도 다시 쓰세요.',
    modeReferenceTitle: '레퍼런스',
    modeReferenceBody: '마음에 드는 사진을 올리면 배치는 그대로 두고 톤·소재·색감만 가져옵니다.',
    modeCleanupTitle: '정리',
    modeCleanupBody: '잡동사니를 치우고 빈 방의 모습을 봅니다.',
    modeLayoutTitle: '배치',
    modeLayoutBody: '가구를 바꾸지 않고, 있는 가구의 자리만 다시 잡습니다.',
    modePlanTitle: '평면도',
    modePlanBody: '평면도를 집 전체 3D 뷰로, 대충 그린 스케치를 깔끔한 도면으로.',
    editEyebrow: '부분 편집',
    editTitle: '한 번에 하나씩 바꾸세요.',
    editBody: '소파만 마음에 안 드나요? 동그라미 치고 원하는 걸 적으세요. archelier 는 그 부분만 다시 그리고 나머지는 그대로 둡니다 — 벽 색, 러그, 조명, 그림도 마찬가지.',
    editPrompt: '빈티지 가죽 소파',
    shopTitle: '보이는 그대로 쇼핑.',
    shopBody: '디자인마다 가구 목록·컬러 팔레트·조명 계획이 함께 오고, 가구마다 비슷한 제품을 찾는 링크가 붙습니다.',
    gioEyebrow: 'Gio',
    gioTitle: '디자이너와 상의하듯.',
    gioBody: 'Gio 는 탭 하나를 차지한 AI 공간 디자이너입니다. 내 방 사진, 마음에 드는 공간의 사진이나 링크, 내 디자인을 보내면 방향을 제안하고 대화 안에서 바로 디자인을 만들거나 고쳐 줍니다.',
    gioRole: '공간 디자이너',
    gioUser: '저희 주방이랑 식탁 쪽인데 좀 차가운 느낌이에요. 아이디어 있을까요?',
    gioReply: '차가운 마감 대신 따뜻한 나무, 부드러운 패브릭, 낮은 간접 조명을 겹쳐 볼게요. 이런 방향은 어떨까요:',
    gioCardTitle: '따뜻한 재팬디',
    gioCardBody: '내추럴 오크와 질감 있는 미장 벽이 공간에 바로 온기를 더합니다.',
    gioCardAction: '만들기',
    priceEyebrow: '가격',
    priceTitle: '매일 무료. 구독 없음.',
    price1: '매일 무료 디자인, 현지 자정에 다시 채워집니다',
    price2: '가입하면 보너스',
    price3: '친구를 초대하면 둘 다 더',
    price4: '더 필요하면 크레딧 팩으로 충전',
    privacyTitle: '내 사진은 내 것.',
    privacyBody: '사진·요청·디자인은 AI 학습이나 광고에 쓰이지 않습니다. 공유하지 않는 한 디자인은 나만 봅니다.',
    faqTitle: '자주 묻는 질문',
    faq1Q: 'archelier 는 무엇인가요?',
    faq1A: 'archelier(Architect + Atelier)는 폰과 웹에서 쓰는 AI 인테리어 디자인 앱입니다. 방을 찍고 스타일을 고르면 바로 그 공간의 포토리얼 리디자인을 받고, 가구마다 이름과 링크가 붙습니다. 실내뿐 아니라 외관과 정원도 됩니다.',
    faq2Q: '어떻게 쓰나요?',
    faq2A: '방 사진을 찍거나 스케치·평면도·3D 화면 캡처를 올립니다. 48가지 스타일 중에서 고르거나 직접 설명하거나 레퍼런스 사진을 올리세요. 약 1분 뒤 내 공간의 포토리얼 렌더와 가구 목록·컬러 팔레트·조명 계획을 받습니다.',
    faq3Q: '무료인가요?',
    faq3A: '네. 구독이 없습니다. 누구나 매일 무료 디자인을 받고(현지 자정에 다시 채워짐), 가입하거나 친구를 초대하면 보너스를 받습니다. 더 필요하면 크레딧 팩을 살 수 있습니다.',
    faq4Q: '평면도를 3D 로 바꿀 수 있나요?',
    faq4A: '네. 평면도 모드는 2D 평면도를 고른 스타일로 집 전체 3D 뷰로 바꿉니다. 손으로 그린 스케치나 흐릿한 도면을 깔끔한 도면이나 컬러 평면도로 바꿀 수도 있습니다.',
    faq5Q: '마음에 드는 사진의 스타일을 따라 할 수 있나요?',
    faq5A: '네. 레퍼런스 스타일을 고르고 참고 사진을 올리세요. 배치는 따라 하지 않고 톤·소재·색감만 가져와 내 방에 입힙니다.',
    faq6Q: '디자인의 일부만 바꿀 수 있나요?',
    faq6A: '네. 소파·러그·벽처럼 바꾸고 싶은 곳에 동그라미를 치고 원하는 걸 적으세요. 그 부분만 다시 그리고 나머지는 그대로 남습니다.',
    faq7Q: 'Gio 는 무엇인가요?',
    faq7A: 'Gio 는 archelier 의 AI 공간 디자이너입니다. 내 방 사진, 마음에 드는 공간의 사진이나 링크, 내 디자인을 보내면 방향을 제안하고, 대화 안에서 디자인을 만들거나 고치고, 색·예산·조명 질문에 답합니다.',
    faq8Q: '내 사진이 AI 학습에 쓰이나요?',
    faq8A: '아니요. archelier 는 사진·요청·디자인을 AI 모델 학습이나 광고에 쓰지 않습니다. 공유하지 않는 한 디자인은 내 계정에서만 보입니다.',
    faq9Q: '어디서 쓸 수 있나요?',
    faq9A: 'App Store, Google Play, 그리고 웹 archelier.co 에서 쓸 수 있습니다. 계정과 디자인은 어디서나 동기화됩니다. 11개 언어를 지원합니다.',
    ctaTitle: '오늘, 내 방을 새로.',
    ctaBody: '폰에서도, 웹에서도. 디자인은 어디서나 이어집니다.',
    langLabel: '언어',
  },
  upgradeToPro: 'Pro 로 업그레이드',
  creditsPerMonth: '매월 {n} 크레딧',
  planFreeName: '무료',
  planFreeTagline: '매달 몇 개의 디자인으로 archelier을 체험해보세요.',
  planProName: 'Pro',
  planProTagline: '질 높은 결과를 원하는 일반 사용자용.',
  planStudioName: 'Studio',
  planStudioTagline: '파워 유저, 팀, 상업적 용도용.',
  planFeatWatermark: '"archelier" 워터마크 포함',
  planFeatNoWatermark: '저장·공유 디자인에 워터마크 없음',
  planFeatUnlimited: '무제한 AI 디자인 생성',
  planFeatUnlimitedChat: '디자인당 AI 챗 무제한 (무료: 3턴)',
  planFeatUnlimitedEdit: '부분 편집 무제한',
  planFeatFeed: '피드에 공유',
  planFeatEverythingPro: 'Pro의 모든 기능 포함',
  planFeatCommercial: '상업적 이용 권한',
  planFeatApiAccess: 'API 접근 (출시 예정)',
  planCtaSubscribe: '구독하기',
  planCtaCurrent: '현재 플랜',
  planPopular: '가장 인기',
  signInToSubscribe: '로그인 후 구독',
  signInToBuy: '로그인 후 구매',
  trialNote: '{n}일 무료 체험',

  creditPacksTitle: '또는 크레딧 팩으로 충전',
  creditPacksSubtitle: '구독 없이 필요할 때 1회 결제.',
  packStarterName: '스타터 팩',
  packStandardName: '스탠다드 팩',
  packProName: '프로 팩',
  packCreditsAmount: '{n} 크레딧',
  packCtaBuy: '구매',
  pricingFootnote: '표시 가격은 USD 기준이며 결제 시 세금이 추가됩니다. 언제든 해지 가능.',
  errBillingGeneric: '요청 처리 중 문제가 발생했어요. 다시 시도해주세요.',

  // Account page
  accountTitle: '설정',
  accountPlanSection: '구독',
  accountCreditsSection: '크레딧',
  accountCreditsDesc: '디자인 생성 시 크레딧이 차감돼요. 언제든 충전할 수 있어요.',
  viewPlans: '플랜 보기',
  changePlan: '플랜 변경',
  manageBilling: '결제 관리',
  manageBillingWebHint: '웹에서 구독하신 경우 archelier.co 에서 관리할 수 있어요.',
  buyCreditPack: '크레딧 팩 구매',
  subRenewsAt: '{date}에 갱신',
  subEndsAt: '{date}에 종료',
  trialEndsAt: '{date}에 무료 체험 종료 — 월 $9.99 자동 전환',
  trialCancelEndsAt: '{date}에 체험 종료 — 자동 갱신 안 됨',
  subStatus_past_due: '결제가 연체됐어요. 결제 수단을 업데이트해주세요.',
  subStatus_canceled: '구독이 해지됐어요.',
  subStatus_unpaid: '결제 미완료 상태예요.',
  subStatus_trialing: '무료 체험 중이에요.',
  account: '계정',
  pricing: '요금',
  upgrade: '업그레이드',

  // Invite / promo page
  inviteTitle: '친구 초대하고 크레딧 받기',
  inviteSubtitle: '친구가 내 링크로 가입하면 나는 +{inviter} 크레딧, 친구는 +{invitee} 크레딧을 받아요.',
  inviteFriends: '친구 초대',
  inviteSignInHint: '로그인하면 내 초대 링크를 받을 수 있어요.',
  yourReferralCode: '내 초대 링크',
  inviteCodeLoading: '초대 링크를 준비하고 있어요…',
  inviteLinkHint: '내 링크로 가입한 친구는 +{n} 크레딧을 받아요.',
  copyLink: '링크 복사',
  shareLink: '링크 공유',
  inviteShareText: 'archelier에서 AI로 내 공간을 리디자인해보세요. 내 링크로 가입하면 +{n} 크레딧이 추가돼요.',
  redeemTitle: '코드가 있나요?',
  redeemDesc: '친구에게 받은 초대 코드나 프로모 코드를 입력하면 보너스 크레딧을 받아요.',
  copyCode: '코드 복사',
  errRefSelf: '자기 초대 코드는 사용할 수 없어요.',
  landingInviteTitle: '친구가 초대했어요 — 두 사람 모두 +{n} 크레딧.',
  landingInviteAutoIos: "앱을 설치한 뒤 이 초대 링크를 한 번 더 누르세요. 앱이 열리고, 가입하면 자동으로 적용돼요.",
  landingInviteAutoAndroid: "아래 Google Play 버튼으로 설치하고 가입하면 자동으로 적용돼요. 안 되어 있으면 설정 → 친구 초대에서 이 코드를 입력하세요.",
  landingInviteDesktop: "여기서 가입하면 바로 적용돼요. 휴대폰 앱으로 받으려면 QR 코드를 찍고 휴대폰에 나오는 안내를 따라 주세요.",
  promoTitle: '프로모 코드가 있나요?',
  promoDesc: '프로모 코드를 입력하면 크레딧을 받을 수 있어요.',
  promoPlaceholder: '예: LAUNCH2026',
  promoRedeem: '적용',
  promoSuccess: '적용 완료 — {n} 크레딧이 추가됐어요.',
  errPromoInvalid: '유효하지 않은 코드예요.',
  errPromoExpired: '만료된 코드예요.',
  errPromoMaxed: '사용 한도에 도달한 코드예요.',
  errPromoUsed: '이미 사용한 코드예요.',
  errPromoUserInit: '페이지를 새로고침한 뒤 다시 시도해주세요.',
  errPromoGeneric: '코드 적용에 실패했어요. 다시 시도해주세요.',

  // Reports / moderation (Phase 8-4)
  reportThisDesign: '이 디자인 신고',
  reportShort: '신고',
  reportTitle: '디자인 신고',
  reportDesc: '어떤 문제가 있나요? 신고 내역은 관리자만 확인할 수 있어요.',
  reportReason_spam: '스팸/광고',
  reportReason_nsfw: '선정적/부적절 콘텐츠',
  reportReason_copyright: '저작권 침해',
  reportReason_other: '기타',
  reportNotePlaceholder: '추가 설명 (선택, 500자 이내)',
  reportSubmit: '신고 제출',
  reportSubmitting: '제출 중…',
  reportSignInHint: '신고하려면 로그인이 필요해요.',
  reportThanks: '신고가 접수됐어요',
  reportThanksDesc: '검토 후 필요한 조치를 취할게요. 감사합니다.',
  errReportGeneric: '신고 접수에 실패했어요. 잠시 후 다시 시도해주세요.',

  // 차단 기능 (App Review Guideline 1.2)
  blockUser: '이 사용자 차단',
  unblockUser: '차단 해제',
  blockShort: '차단',
  blockConfirm: '@{handle} 님을 차단할까요? 차단하면 이 사용자의 디자인이 내 피드/프로필에서 숨겨지고, 서로 상호작용할 수 없게 됩니다.',
  blockedUsersMenu: '차단한 사용자',
  blockedUsersTitle: '차단한 사용자',
  blockedUsersDesc: '차단한 사용자 목록이에요. 이 사용자들의 디자인은 피드와 프로필에서 숨겨집니다.',
  blockedUsersEmpty: '차단한 사용자가 없어요.',
  profileBlocked: '이 사용자를 차단했어요.',
  profileBlockedAction: '차단을 해제하면 디자인을 다시 볼 수 있어요.',
  errBlockGeneric: '차단 상태 변경에 실패했어요. 다시 시도해주세요.',
  errBlockedCustomCommand: '입력한 요청에 허용되지 않는 단어가 포함되어 있어요.',
  moderationAutoUnlisted: '이 디자인이 자동 검토로 피드에서 내려갔어요. 문제가 없다고 판단되시면 관리자에게 문의해주세요.',

  // Language name used in AI prompt
  promptLang: 'Korean',
};
